import { FormControl, FormControlProps, FormHelperText, TextFieldProps } from '@material-ui/core';
import React from 'react';

import FormTextFieldRedesign from 'retired/FormTextFieldRedesign';

export type FormSelectRedesignProps = {
  formControlProps?: FormControlProps;
  input?: TextFieldProps;
  meta?: { touched?: boolean; error?: boolean; dirty?: boolean };
  alwaysDisplayErrors?: boolean;
} & TextFieldProps;
const FormSelectRedesign: React.FC<FormSelectRedesignProps> = ({
  fullWidth = false,
  required,
  label,
  helperText,
  input = {},
  meta,
  formControlProps = {},
  defaultValue,
  children,
  ...rest
}) => (
  <FormControl
    required={required}
    fullWidth={fullWidth}
    error={meta?.touched && meta?.error}
    {...formControlProps}
  >
    <FormTextFieldRedesign
      inputProps={{
        id: input.name,
        style: { borderRadius: 16 },
      }}
      select
      variant="outlined"
      label={label}
      required={required}
      meta={meta}
      {...rest}
      {...input}
    >
      {children}
    </FormTextFieldRedesign>
    {helperText ? <FormHelperText>{helperText}</FormHelperText> : null}
  </FormControl>
);

export default FormSelectRedesign;
